// reducers.js
import { createStore } from 'redux';

const initialState = {
  username: '',
};

const counterReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'modifyUsername':
      return { ...state, username: action.username };
    case 'DECREMENT':
      return { ...state, username: action.username };
    default:
      return state;
  }
};

const store = createStore(counterReducer);

export default store;
